import { urlForImage } from 'lib/sanity.image'

import { PortableText } from '@portabletext/react'
import { GlobalLink } from './Global/GlobalLink'
import Image from 'next/image'
import { DonationTag } from './Global/DonationTag'

const TextComponents: any = {
  block: {
    normal: ({ children }) => (
      <p className="pb-12 text-12 leading-120 text-darkGray last-of-type:pb-0">
        {children}
      </p>
    ),
  },
}

export const DonationCard = ({
  title,
  subtitle,
  amount,
  description,
  image,
  link,
  grid = true,
  className = '',
}) => {
  return (
    <div
      data-carousel-item
      className={`relative inline-block select-none overflow-hidden rounded-12 bg-white ${
        !grid ? 'mr-10 w-[85%] md:mr-24 md:w-[45%]' : 'md:w-full'
      } ${className}`}
    >
      {!grid ? (
        <DonationTag
          amount={amount}
          className="absolute left-20 top-20 z-[5]"
        />
      ) : null}
      {image ? (
        <div className="pointer-events-none relative aspect-[2/2.5] w-full bg-lighterGray md:aspect-[1/1]">
          <Image
            src={urlForImage(image).width(600).dpr(3).url()}
            fill
            style={{ objectFit: 'cover' }}
            alt={`Display image for ${title} Charity`}
            placeholder="blur"
            blurDataURL={image.lqip}
          />
        </div>
      ) : null}
      <div
        className={`flex flex-wrap justify-between p-20 md:flex-nowrap ${
          grid ? 'flex-col' : 'flex-row'
        }`}
      >
        <div>
          <div className="text-bold pb-4 text-12 leading-100 text-darkGray md:text-14">
            {title}
          </div>
          <div className="text-bold pb-20 text-12 leading-100 text-gray md:text-14">
            {subtitle}
          </div>
          {!grid && link ? (
            <GlobalLink
              link={link}
              className="ease inline-block hidden self-start rounded-6 bg-[#F5F5F7] p-10 text-14 leading-110 text-darkGray transition-colors duration-300 hover:bg-yellow md:inline-block"
            >
              {link.label}
            </GlobalLink>
          ) : null}
        </div>
        <div
          className={`whitespace-normal pr-10 ${
            grid ? 'w-full' : 'max-w-[450px] md:w-[55%]'
          }`}
        >
          <PortableText value={description} components={TextComponents} />
        </div>

        <div className={`flex gap-8 pt-20 ${grid ? 'block' : 'md:hidden'}`}>
          {grid ? <DonationTag amount={amount} /> : null}
          {link ? (
            <GlobalLink
              link={link}
              className="ease rounded-6 bg-[#F5F5F7] p-10 text-14 leading-110 text-darkGray transition-colors duration-300 hover:bg-yellow"
            >
              {link.label ?? 'Donate Here'}
            </GlobalLink>
          ) : null}
        </div>
      </div>
    </div>
  )
}
